'use client';

import { createContext, useContext, useState, useMemo } from 'react';

export const HeroContext = createContext(null);

const defaultHeroImages = [];

export function HeroProvider({ children, defaultImage = null, heroImages = defaultHeroImages }) {
  const [image, setImage] = useState(defaultImage);

  const value = useMemo(
    () => ({
      image,
      setImage,
      heroImages
    }),
    [image, setImage, heroImages]
  );

  return <HeroContext.Provider value={value}>{children}</HeroContext.Provider>;
}

export function useHero() {
  const context = useContext(HeroContext);
  if (!context) {
    throw new Error('useHero must be used within a HeroProvider');
  }
  return context;
}
